module.exports = "<p style='font-size: 48px;'>instant-messenger works!</p>\n"